import { FormFieldError } from "../inputs/form-field-error/FormFieldError.js";
import select_module_default from "./select.module.js";
import { Select } from "@mantine/core";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/select/Select.tsx
const Select$1 = ({ data, placeholder, label, error, clearable, disabled, onBlur, onChange, onFocus, required = false, value, renderOption, withScrollArea, scrollAreaProps, "data-testid": testId }) => {
	const hasValue = Boolean(value && value?.toString().trim().length !== 0);
	const err = useMemo(() => {
		if (error && typeof error === "boolean") return true;
		if (error && typeof error === "string") return /* @__PURE__ */ jsx(FormFieldError, { errText: error });
		return null;
	}, [error]);
	return /* @__PURE__ */ jsx(Select, {
		"data-testid": testId,
		data,
		placeholder,
		label,
		error: err,
		clearable,
		comboboxProps: { transitionProps: {
			transition: "pop",
			duration: 200
		} },
		withCheckIcon: false,
		onChange,
		disabled,
		radius: "xxs",
		classNames: select_module_default,
		onBlur,
		onFocus,
		value,
		size: "xl",
		required,
		labelProps: { "data-floating": hasValue },
		renderOption,
		withScrollArea,
		scrollAreaProps
	});
};

//#endregion
export { Select$1 as Select };